<template>
  <v-container fluid class="px-4 py-5 text-center">
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackState"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>

    <!-- Dialog: CONFIRMAR ACCION -->
    <v-dialog v-model="dialog" max-width="350">
      <v-card class="py-3">
        <v-card-title class="headline">
          ¿Desea "{{ textGuardarTurno }}"?
        </v-card-title>
        <v-card-text class="subtitle-1">
          Confirmar esta acción es para
          <span class="font-weight-medium">"{{ textGuardarTurno }}"</span>, con
          la grúa
          <span class="font-weight-medium"> {{ getNombreGrua }}.</span>
        </v-card-text>
        <v-card-actions class="px-6">
          <v-btn color="primary" outlined @click="dialog = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="guardarTurno"> Aceptar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout column>
      <v-layout>
        <v-flex xs12>
          <h1>{{ mensajeBienvenida }}</h1>
        </v-flex>
      </v-layout>

      <v-layout class="mt-4">
        <v-flex xs12>
          <h2>¿Qué grúa utilizaremos hoy?</h2>
        </v-flex>
      </v-layout>

      <v-layout class="text-center mt-8">
        <v-spacer></v-spacer>
        <v-flex xs12 sm6 md6>
          <v-autocomplete
            v-model="gruaDisponibleId"
            :loading="loadGruasDisponibles"
            :items="gruasDisponibles"
            item-value="proveedorId"
            item-text="nombre"
            label="Seleccionar Grúa"
            @click="verificarGruasDisponibles"
            clearable
            :disabled="turnoActivo"
            dense
          ></v-autocomplete>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>

      <v-layout class="text-center mt-8" v-if="gruaDisponibleId">
        <v-spacer></v-spacer>

        <v-flex xs12 sm6 md6>
          <v-tabs
            v-model="tab"
            background-color="transparent"
            color="basil"
            grow
          >
            <v-tab>CheckList</v-tab>
            <v-tab>Imagenes</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-flex xs12>
                <v-card outlined>
                  <v-card-title class="text-h6">
                    Seleccione las opciones adecuadas
                  </v-card-title>

                  <v-card-text>
                    <!-- EQUIPAMIENTO -->
                    <v-card outlined class="mb-4">
                      <v-card-title class="text-subtitle-1 font-weight-bold">
                        Equipamiento
                      </v-card-title>

                      <v-card-text>
                        <v-row class="pa-0 ma-0">
                          <v-col
                            v-for="item in checklist.equipamiento"
                            :key="item.id"
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-checkbox
                              v-model="item.checked"
                              :label="item.nombre"
                              hide-details
                              dense
                              class="mt-0"
                            />
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <!-- LUCES -->
                    <v-card outlined class="mb-4">
                      <v-card-title class="text-subtitle-1 font-weight-bold">
                        Luces
                      </v-card-title>

                      <v-card-text>
                        <v-row class="pa-0 ma-0">
                          <v-col
                            class="pa-0 ma-0"
                            v-for="item in checklist.luces"
                            :key="item.id"
                            cols="12"
                            sm="6"
                            md="3"
                          >
                            <v-checkbox
                              v-model="item.checked"
                              :label="item.nombre"
                              hide-details
                              dense
                              class="mt-0"
                            />
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <!-- AUDIO -->
                    <v-card outlined>
                      <v-card-title class="text-subtitle-1 font-weight-bold">
                        Audio
                      </v-card-title>

                      <v-card-text>
                        <v-row class="pa-0 ma-0">
                          <v-col
                            class="pa-0 ma-0"
                            v-for="item in checklist.audio"
                            :key="item.id"
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-checkbox
                              v-model="item.checked"
                              :label="item.nombre"
                              hide-details
                              dense
                              class="mt-0"
                            />
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-card-text>
                  <v-card-text>
                    <v-textarea
                      v-model="checklist.observaciones"
                      outlined
                      dense
                      hint="Registre cualquier detalle, anomalía o elemento no contemplado en el checklist."
                      label="Observaciones (opcional)"
                    ></v-textarea>
                  </v-card-text>
                </v-card>
                <v-btn
                  color="primary"
                  width="100%"
                  @click="tab = 1"
                  class="my-3"
                  >Siguiente</v-btn
                >
              </v-flex>
            </v-tab-item>
            <v-tab-item>
              <ArchivosGrua
                :nombre-grua="getNombreGrua"
                @ruta-base="rutaBase = $event"
                :turno-activo="this.turnoActivo"
              />

              <v-btn color="primary" width="100%" @click="tab = 0" class="mb-3"
                >Anterior</v-btn
              >
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>

      <!-- <v-layout>
        <v-spacer></v-spacer>
        <v-flex xs12 sm6 md6 text-center>
          <v-btn
            v-if="turnoActivo"
            color="primary"
            :disabled="
              !rutaBase && turno.detalleHistorialOperadoresGruas.length == 0
            "
            width="100%"
            @click="dialog = true"
            >{{ textGuardarTurno }}</v-btn
          >
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout> -->
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import ArchivosGrua from "./ArchivosGrua.vue";
import { setTimeout } from "core-js";

export default {
  components: {
    ArchivosGrua,
  },
  data() {
    return {
      rutaBase: "",
      checklist: {
        equipamiento: [
          { id: 1, nombre: "Fajas", checked: false },
          { id: 2, nombre: "Llantas", checked: false },
          { id: 3, nombre: "Extintor", checked: false },
          { id: 4, nombre: "Llanta de repuesto", checked: false },
          { id: 5, nombre: "Mica", checked: false },
          { id: 6, nombre: "Llave de rueda", checked: false },
          { id: 7, nombre: "Cono", checked: false },
          { id: 8, nombre: "Cinchas de amarre", checked: false },
          { id: 9, nombre: "Cadenas", checked: false },
        ],
        luces: [
          { id: 11, nombre: "Frontales", checked: false },
          { id: 12, nombre: "Traseras", checked: false },
          { id: 13, nombre: "Vías", checked: false },
          { id: 14, nombre: "Stop", checked: false },
        ],
        audio: [
          { id: 15, nombre: "CD Player", checked: false },
          { id: 16, nombre: "Bocinas extras", checked: false },
        ],
        observaciones: "",
      },
      tab: 0,
      snackState: false,
      snackColor: "primary",
      snackText: "",
      snackTime: 3500,
      gruaDisponibleId: null,
      gruasDisponibles: [],
      nombreGrua: "",
      loadGruasDisponibles: false,
      turno: {},
      turnoActivo: false,
      dialog: false,
    };
  },
  created() {
    if (this.$store.state.usuario) {
      if (this.$store.state.usuario.rol != "Operador Grua") {
        this.$router.push({ name: "novedades" });
      } else {
        this.verificarTurno();
      }
    } else {
      this.$router.push({ name: "login" });
    }
  },
  watch: {
    async rutaBase(nuevaRuta) {
      if (nuevaRuta && !this.turnoActivo) {
        await this.iniciarTurno();
      }

      if (nuevaRuta && this.turnoActivo) {
        await this.cerrarTurno();
      }
    },
  },
  computed: {
    mensajeBienvenida() {
      return (
        `Bienvenido/a, ${this.$store.state.usuario.nombre}!` || `Bienvenido/a!`
      );
    },
    textGuardarTurno() {
      return this.turnoActivo ? "Finalizar Turno" : "Iniciar Turno";
    },
    getNombreGrua() {
      if (!this.gruaDisponibleId) return "";

      return this.gruasDisponibles.filter(
        (g) => g.proveedorId == this.gruaDisponibleId,
      )[0].nombre;
    },
  },
  methods: {
    verificarTurno() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/HistorialOperadoresGrua/VerificarTurno/${this.$store.state.usuario.idUsuario}`,
          configuracion,
        )
        .then((res) => {
          this.turno = res.data;

          this.turnoActivo = this.turno.historialOperadoresGruaId
            ? true
            : false;

          if (this.turnoActivo) {
            this.gruasDisponibles.push({
              proveedorId: res.data.proveedorId,
              nombre: res.data.proveedor.nombre,
            });

            this.gruaDisponibleId = res.data.proveedorId;
          } else {
            this.verificarGruasDisponibles();
          }
        })
        .catch((err) => console.error(err));
    },
    verificarGruasDisponibles() {
      this.loadGruasDisponibles = true;
      this.gruaDisponibleId = null;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/HistorialOperadoresGrua/GruasDisponibles", configuracion)
        .then((res) => {
          this.gruasDisponibles = res.data;
        })
        .catch((err) => console.error(err))
        .finally(() => {
          this.loadGruasDisponibles = false;
        });
    },
    guardarTurno() {
      if (this.turnoActivo) {
        this.cerrarTurno();
      } else {
        this.iniciarTurno();
      }
      this.dialog = false;
    },
    async iniciarTurno() {
      let header = {
        Authorization: "Bearer " + this.$store.state.token,
      };

      let configuracion = {
        headers: header,
      };

      try {
        const res = await axios.post(
          "api/HistorialOperadoresGrua",
          {
            proveedorId: this.gruaDisponibleId,
            usuarioId: this.$store.state.usuario.idUsuario,
          },
          configuracion,
        );

        this.snackState = true;
        this.snackText = "¡Grúa seleccionada con éxito!";
        this.snackColor = "green";
        this.turno = res.data;
        await this.guardarDetalleTurno();
        this.verificarTurno();
      } catch (err) {
        this.snackState = true;
        this.snackText = `Lo sentimos, la grúa ${this.getNombreGrua} ya fue seleccionada. Intente nuevamente.`;
        this.snackColor = "red";
        this.snackTime = 4000;

        await this.verificarGruasDisponibles();

        console.error(err);
      }
    },
    async guardarDetalleTurno() {
      const header = {
        Authorization: "Bearer " + this.$store.state.token,
      };

      const configuracion = {
        headers: header,
      };

      const request = {
        historialOperadoresGruaId: this.turno.historialOperadoresGruaId,
        inicioTurno: this.turnoActivo,

        // EQUIPAMIENTO
        fajas: this.checklist.equipamiento[0].checked,
        llantas: this.checklist.equipamiento[1].checked,
        extintor: this.checklist.equipamiento[2].checked,
        llantaRepuesto: this.checklist.equipamiento[3].checked,
        mica: this.checklist.equipamiento[4].checked,
        llaveRueda: this.checklist.equipamiento[5].checked,
        cono: this.checklist.equipamiento[6].checked,
        cinchasAmarre: this.checklist.equipamiento[7].checked,
        cadenas: this.checklist.equipamiento[8].checked,

        // LUCES
        lucesFrontales: this.checklist.luces[0].checked,
        lucesTraseras: this.checklist.luces[1].checked,
        lucesVias: this.checklist.luces[2].checked,
        lucesStop: this.checklist.luces[3].checked,

        // AUDIO
        cdPlayer: this.checklist.audio[0].checked,
        bocinasExtras: this.checklist.audio[1].checked,

        observaciones: this.checklist.observaciones,
        rutaBase: this.rutaBase,
      };

      try {
        await axios.post(
          "api/HistorialOperadoresGrua/Detalle",
          request,
          configuracion,
        );

        await new Promise((resolve) => setTimeout(resolve, 1500));

        this.snackState = true;
        this.snackText = "¡Esta página se actualizará en unos segundos!";
        this.snackColor = "green";

        await new Promise((resolve) => setTimeout(resolve, 3500));

        location.reload();
      } catch (err) {
        console.error(err);

        throw err;
      }
    },
    async cerrarTurno() {
      let header = {
        Authorization: "Bearer " + this.$store.state.token,
      };

      let configuracion = {
        headers: header,
      };

      try {
        await axios.put(
          `api/HistorialOperadoresGrua/${this.$store.state.usuario.idUsuario}`,
          null,
          configuracion,
        );

        this.snackState = true;
        this.snackText = "¡Turno Finalizado con éxito!";
        this.snackColor = "green";

        await this.guardarDetalleTurno();

        this.verificarTurno();
        this.gruaDisponibleId = null;
      } catch (err) {
        if (err.response.status == 404) {
          this.verificarTurno();
        }
        console.error(err);
      }
    },
  },
};
</script>
